export default __webpack_public_path__ + "static/media/information-icon.b8e11cbe.svg";